import "./AISection.css";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLocale } from "@/i18n/useLocale";
import { SOLUTION_PREFIX } from "@/i18n/config";
import SectionCta from "@/components/SectionCta/SectionCta";
import SolutionLink from "@/components/SolutionLink/SolutionLink";
import { audioplayerElGraficoWidget, audioplayerElGraficoVoiceClone } from "@/assets";

function AISection() {
  const { t, locale } = useLocale();
  const textRef = useScrollReveal<HTMLDivElement>();
  const mockupsRef = useScrollReveal<HTMLDivElement>({ delay: 120 });
  const footerRef = useScrollReveal<HTMLDivElement>({ delay: 200 });

  return (
    <section className="ai-section" id="ia">

      <div className="ai-section__content">
        <div className="ai-section__main">
          <div className="ai-section__text reveal--from-left" ref={textRef}>
            <span className="ai-section__badge">{t.ai.badge}</span>

            <h2 className="ai-section__title">{t.ai.title}</h2>

            <p className="ai-section__description">{t.ai.description}</p>

            {/* La landing de solucion -la money page- recibe de aca su enlace
                interno desde el cuerpo de la home. Va como tarjeta y justo
                despues del texto: de enlace subrayado de 15px quedaba como una
                nota al pie, y en mobile hasta aparecia arriba del titulo. */}
            <SolutionLink
              to={`${SOLUTION_PREFIX[locale]}/automatizacion-procesos-ia`}
              label={t.ai.solutionLink}
              kicker={t.solutionCard.kicker}
              variant="ai"
            />
          </div>

          {/* Antes: mockups genericos sin caso real detras (mockup-tablet-
              analytics, mockup-mobile-ecommerce-1/2), la unica de las tres
              secciones de servicio del Home que no mostraba un proyecto
              entregado. Ahora: capturas reales del Audio Player con IA que
              construimos para El Gráfico, ya en produccion. */}
          <div className="ai-section__right reveal--zoom" ref={mockupsRef}>
            <div className="ai-section__mockups mockups">
              <img
                loading="lazy"
                src={audioplayerElGraficoWidget}
                alt="Reproductor de audio narrado con IA de WAIA, en vivo en El Gráfico"
                title="Audio Player de WAIA en El Gráfico"
                className="mockup ai-section__mockup ai-section__mockup--primary"
              />

              <img
                loading="lazy"
                src={audioplayerElGraficoVoiceClone}
                alt="Clonación de voz de un periodista de El Gráfico, con el Audio Player de WAIA"
                title="Clonación de voz del Audio Player de WAIA"
                className="mockup ai-section__mockup ai-section__mockup--secondary"
              />
            </div>
          </div>
        </div>

        <div className="ai-section__footer" ref={footerRef}>
          <SectionCta
            label={t.sectionCta.ai}
            variant="ai"
          />
        </div>
      </div>
    </section>
  );
}

export default AISection;
